import { supabase } from '@/integrations/supabase/client';
import { QueryClient } from '@tanstack/react-query';
import { storage } from './storage';

/**
 * Safe sign-out with local/global options
 * Defaults to local sign-out to prevent affecting other devices
 */
export async function signOut(allDevices = false, queryClient?: QueryClient) {
  try {
    await supabase.auth.signOut({ scope: allDevices ? 'global' : 'local' });
  } catch (e) {
    console.error('signOut failed', e);
    // Don't break UI if signOut throws - continue with cleanup
  } finally {
    // Clear client-only state; other devices unaffected
    if (queryClient) {
      queryClient.clear();
    }
    
    // Clear app-specific storage safely
    storage.clearApp();
    
    // Navigate to login (this will be handled by the calling component)
    return '/coming-soon';
  }
}

/**
 * Sign out with confirmation modal for global option
 */
export async function signOutWithConfirmation(
  queryClient?: QueryClient,
  showGlobalOption = false
): Promise<{ path: string; allDevices: boolean }> {
  if (showGlobalOption) {
    // In a real implementation, this would show a modal
    // For now, we'll default to local sign-out
    const path = await signOut(false, queryClient);
    return { path: path || '/coming-soon', allDevices: false };
  }
  
  const path = await signOut(false, queryClient);
  return { path: path || '/coming-soon', allDevices: false };
}
